var $ = require("./lib/qsa")

var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var pymChild = null;
var isMobile = isMobile.matches;
var hasStarted = false;

var artboards = ["g-_ai2html-map-small","g-_ai2html-map-wide"];

var onWindowLoaded = function() {
  pym.then(child => {
    pymChild = child;
    child.sendHeight();
    window.addEventListener("resize", render);
  });

  initUI();
}

/*
 * Render the graphic.
 */
var render = function() {
  // Update iframe
  if (pymChild) {
    pymChild.sendHeight();
  }
}

var initUI = function() {
  document.querySelectorAll('.graphic').forEach(function(wrapper) {
    var toggleTimeout;
    var toggleButtons = wrapper.querySelectorAll('.toggle-btn');
    var splitId = toggleButtons[0].getAttribute('id').split('-');    

    // turn on damage g's that are "active"...what to do first. 
    artboards.forEach(a => {
      // hide all gs
      $(`[data-name^='diff damage'`).forEach(o => o.classList.remove("active"))    

      // show active gs
      $(`#${splitId[1]}`).forEach(o => o.classList.add("active"))
    })

    toggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var parentToggleWrap = button.parentElement;
        parentToggleWrap.classList.add('clicked');
        window.clearTimeout(toggleTimeout);

        splitId = button.getAttribute('id').split('-');

        if (splitId[1] !== "diff_damage_20231006") {
          $.one(".key-item.key-0").classList.add("active")
        } else {
          $.one(".key-item.key-0").classList.remove("active")
        }

        if (splitId[1] !== "diff_damage_20231105" && splitId[1] !== "diff_damage_20231006") {
          $.one(".key-item.key-1").classList.add("active")
        } else {
          $.one(".key-item.key-1").classList.remove("active")
        }

        // turn on damage g's that are "active"
        artboards.forEach(a => {
          // hide all damage g's
          $(`[data-name^='diff damage'`).forEach(o => o.classList.remove("active"));    
          $(`[data-name^='diff damage'`).forEach(o => o.classList.remove("dim"));
          
          // remove extras
          $(`div[id^='t-']`).forEach(o => o.classList.remove("active"));
          // $(`svg[class^='${a}-s']`).forEach(o => o.classList.remove("active"));

          var thisIndex = splitId[2];

          var extraSVG = DATA[thisIndex-1]["extra-svg"].split(", ");
          var extraLABEL = DATA[thisIndex-1]["extra-annotation"].split(", ");
          // show all svg prior to this one
          for (var i = 0; i < thisIndex; i++) {
            var preItem = DATA[i].id;
            $(`#${preItem}`).forEach(o => o.classList.add("dim"))
          }

          // show active damage g's
          $(`#${splitId[1]}`).forEach(o => o.classList.add("active"))

          // change legend 
          $.one(".dynamic-date").innerHTML = DATA[thisIndex-1].prevDate;

          extraSVG.forEach(z => {
            $(`svg[class^='${a}-s-${z}']`).forEach(o => o.classList.add("active"));
          })
          extraLABEL.forEach(z => {        
            $(`div[id^='${z}']`).forEach(o => o.classList.add("active"));           
          })
        })   
        
        if (!button.classList.contains('active')) {
          let activeToggleBtn = parentToggleWrap.querySelector('.toggle-btn.active');
          if (activeToggleBtn) {
            activeToggleBtn.classList.remove('active');
          }
          button.classList.add('active');
        }
      });
    });

    var autoToggle = function() {    
      var stepList = DATA.map(d => d.id); //get IDs from google docs          

      toggleStep(0);

      function toggleStep(step_i) {
        if (step_i < stepList.length) {        
          var step = stepList[step_i];

          // if not already clicked, do auto
          if (!wrapper.querySelector('.image-toggle').classList.contains('clicked')) {
            
            if (step !== "diff_damage_20231006") {
              $.one(".key-item.key-0").classList.add("active")
            } else {
              $.one(".key-item.key-0").classList.remove("active")
            }

            if (step !== "diff_damage_20231105" && step !== "diff_damage_20231006") {
              $.one(".key-item.key-1").classList.add("active")
            } else {
              $.one(".key-item.key-1").classList.remove("active")
            }

            artboards.forEach(a => {
              // dim all damage g's
              $(`[data-name^='diff damage'`).forEach(o => o.classList.remove("active"));    
              $(`[data-name^='diff damage'`).forEach(o => o.classList.remove("dim"));
              
              // remove extras
              $(`div[id^='t-']`).forEach(o => o.classList.remove("active"));
              // $(`svg[class^='${a}-s']`).forEach(o => o.classList.remove("active"));


              // show all svg prior to this one
              for (var i = 0; i < step_i; i++) {
                var preItem = DATA[i].id;
                $(`#${preItem}`).forEach(o => o.classList.add("dim"))
              }

              // show active damage g's
              $(`#${step}`).forEach(o => o.classList.add("active"))

              // change legend 
              $.one(".dynamic-date").innerHTML = DATA[step_i].prevDate;

              var extraSVG = DATA[step_i]["extra-svg"].split(", ");
              var extraLABEL = DATA[step_i]["extra-annotation"].split(", ");
              extraSVG.forEach(z => {
                $(`svg[class^='${a}-s-${z}']`).forEach(o => o.classList.add("active"));
              })
              extraLABEL.forEach(z => {        
                $(`div[id^='${z}']`).forEach(o => o.classList.add("active"));
              })
            })


            let activeToggleBtn = wrapper.querySelector('.toggle-btn.active');
            if (activeToggleBtn) {
                activeToggleBtn.classList.remove('active');
            }
            
            wrapper.querySelector('[id^=toggle-' + step).classList.add('active');
            
            toggleTimeout = window.setTimeout(toggleStep, 2000, step_i + 1);
          }
        }
      }
    };

    //start looping through frames once graphic is visible
    var observer = new IntersectionObserver(intersectionCallback, {threshold: 0.25});
    var target = document.querySelector(".target");
    observer.observe(target);
    
    function intersectionCallback(entries, observer){
      entries.forEach(entry=> {
        if(entry.isIntersecting){
          //only start animation once
          if(hasStarted) return;

          autoToggle();
          hasStarted = true;
        }
      })
    }
  });
};
/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
